import api from './api';

export interface PersonaInsight {
  name: string;
  goals: string[];
  pains: string[];
  objections: string[];
  featureRequests: string[];
  verbatims: string[];
  buyingSignals: string[];
}

export interface PersonaInsightsReport {
  transcriptsAnalyzed: number;
  confidence: string;
  personas: PersonaInsight[];
  recommendations: string[];
}

export interface AnalyzeResult {
  report: PersonaInsightsReport | null;
  raw?: string;
  provider: string;
  model: string;
}

class PersonaInsightsService {
  async analyze(transcripts: string, focusPersona?: string): Promise<AnalyzeResult> {
    const response = await api.post('/persona-insights/analyze', { transcripts, focusPersona });
    return response.data;
  }
}

const personaInsightsService = new PersonaInsightsService();
export default personaInsightsService;
